import axios from 'axios';

// Единый API-клиент. Все запросы к бэкенду идут через него:
// - токен подставляется автоматически из localStorage
// - при 401 с протухшим токеном сессия сбрасывается глобально (событие auth:logout)
export const API_URL = process.env.REACT_APP_API_URL || '/api';
export const TOKEN_KEY = 'token';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    // 401 при наличии токена = токен протух/отозван. 401 без токена (неверный пароль) не трогаем.
    if (err.response?.status === 401 && localStorage.getItem(TOKEN_KEY)) {
      localStorage.removeItem(TOKEN_KEY);
      window.dispatchEvent(new Event('auth:logout'));
    }
    return Promise.reject(err);
  }
);

// Человекочитаемое сообщение из ошибки axios (для toast)
export function apiError(err, fallback = 'Ошибка запроса') {
  if (err?.response?.data?.error) return err.response.data.error;
  if (err?.message === 'Network Error') return 'Нет соединения с сервером';
  return fallback;
}

export default api;
